import { Box, styled } from 'decentraland-ui2'

const IconWrapper = styled(Box)({
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
})

export { IconWrapper }
